import {Button, Loader, Modal} from '@yandex-delivery/blocks'
import React, {memo} from 'react'

import * as classes from './BoundCardModal.classes'
import {useBoundCardModal} from './BoundCardModal.hooks'
import {Props} from './BoundCardModal.types'
import {PaymentCardList} from './PaymentCardList'
import {TrustModal} from './TrustModal'

export const BoundCardModal = memo<Props>(function BoundCardModal(props) {
  const {onClose, offerAgreement, notificationsAgreement} = props
  const {
    isPending,
    error,
    agreement,
    cards,
    card,
    isNotificationsInteracted,
    fetchBoundCard,
    fetchCardBoundContext,
    successHandler,
    updateHandler,
  } = useBoundCardModal(props)

  function renderChildren() {
    if (isPending) {
      return (
        <Modal.Body p="m">
          <Loader />
        </Modal.Body>
      )
    }

    if (cards) {
      if (cards.length > 0) {
        return (
          <PaymentCardList
            agreement={!isNotificationsInteracted ? agreement || offerAgreement : ''}
            card={card}
            cards={cards}
            fetchBoundCard={fetchBoundCard}
            fetchCardBoundContext={fetchCardBoundContext}
            isNotificationsInteracted={isNotificationsInteracted}
            notificationsAgreement={!isNotificationsInteracted ? notificationsAgreement : ''}
            onAdd={updateHandler}
            onSuccess={successHandler}
            subtitle={props.subtitle}
            title={props.title}
            isCheckedOfferAgreement={props.isCheckedOfferAgreement ?? true}
          />
        )
      }

      return <TrustModal fetchCardBoundContext={fetchCardBoundContext} onClose={onClose} onSuccess={updateHandler} />
    }

    if (error) {
      return (
        <Modal.Body p="m">
          <Button onPress={updateHandler} variant="action">
            Повторить
          </Button>
        </Modal.Body>
      )
    }

    return '🤷'
  }

  return (
    <Modal className={classes.modal} onClose={onClose} opened>
      {renderChildren()}
    </Modal>
  )
})
